<template lang="pug">
  .presentation.column(v-if='!!presentation')
    .resource.row
      .item-1.author-tooltip-container.column.start
        router-link.row.middle.center.m-top-2.m-bottom-1(v-if='isPurchased' :to='`/resource/${this.$route.params.id}/t`')
          p.dark-gray.text-normal.bold.m-right-1
            | {{ innerI18n.t('presentationTab.explore') }}
          simple-svg.dark-gray-icon.m4-top-1(:filepath='arrowRight' :width='"20px"' :height='"20px"')
        .info.column.start.top.m-bottom-6
          h1.title-medium.m-bottom-5.title-big2.text-overflow
            | {{ presentation.rhetoricalQuestion }}
          .column.top.start.m-bottom-4
            h2.m-bottom-1.title-small
              | {{ innerI18n.t('presentationTab.benefits') }}
            p.benefits-desc.text-normal.text-overflow
              | {{ presentation.benefits }}
        .info.column.start.top(v-if='!isKrea')
          .rating.row.middle.center
            stars(:stars='presentation.stars' :size='"big"')
            h2.white.text-normal.dark-gray {{ innerI18n.tc('presentationTab.reviews', presentation.reviewCount) }}
          button.rating-button.rating-button-section(v-if='isPurchased' @click='showElement({ element: "feedbackModal" })')
            | {{ innerI18n.t('presentationTab.rateResource') }}
        author-bio-tooltip.bottom(:author='resource.author' styleClass='author-bio-popover program-author-popover')
          .author.row
            img.author-avatar(:src='resource.author.picture || defaultProfileImage' :alt='`${resource.author.name} avatar`')
            span.text-big.black.m-bottom-1
              | {{ resource.author.name }}
            span.text-normal.dark-gray
              | {{ resource.author.bio }}
      .item-1.column.start.top(v-if='presentation')
        .media-box.column.middle.center(v-if='presentation.media')
          img.media-picture(:src='presentation.media' v-if='mediaIsNotVideo')
          .video(v-else v-html='presentationHtml')
        .materials-items.row.space-between(v-if='hasMaterials')
          p.text-small.dark-gray
            | {{ innerI18n.t('presentationTab.need') }}
          .row.middle(v-show='presentation.materials.Electronic')
            img.small-icon.m-right-05(src='../../assets/ic_material_electronic.svg' alt='electronic material logo')
            p.text-normal
              | {{ innerI18n.t('presentationTab.electronicMaterial') }}
          .row.middle(v-show='presentation.materials.Physical')
            img.small-icon.m-right-05(src='../../assets/ic_material_class.svg' alt='class material logo')
            p.text-normal
              | {{ innerI18n.t('presentationTab.classMaterial') }}
          .row.middle(v-show='presentation.materials.Downloadable')
            img.small-icon.m-right-05(src='../../assets/ic_download.svg' alt='download material logo')
            p.text-normal
              | {{ innerI18n.t('presentationTab.downloadMaterial') }}
        .media-box-divider.width-100.m-top-1.m-bottom-3(v-if='presentation.media')
        .graphics-items(v-if='!isTeacherTraining')
          .item.row.top.start(v-if='presentation.ageRange')
            img.item-logo(src='../../assets/ic_user.svg' width='22px' alt='resource age logo')
            .item-info.column.top.start
              h3.m-bottom-05.text-small.dark-gray
                | {{ innerI18n.t('presentationTab.age') }}
              p.row.middle.text-normal.age-desc(:style='getAgeRangeStyle(presentation.ageRange.mainColor)')
                | {{ presentation.ageRange.minAge }} {{ innerI18n.t('teacher.ageSeparator')}} {{ presentation.ageRange.maxAge }} {{ innerI18n.t('teacher.years')}}
              p.row.middle.text-normal.age-desc.m-top-1(
                v-if='presentation.secondaryAgeRange'
                :style='getAgeRangeStyle(presentation.secondaryAgeRange.mainColor)'
              )
                | {{ presentation.secondaryAgeRange.minAge }} {{ innerI18n.t('teacher.ageSeparator')}} {{ presentation.secondaryAgeRange.maxAge }} {{ innerI18n.t('teacher.years')}}
          .item.row.top.start
            img.item-logo(src='../../assets/ic_areas.svg' width='20px' alt='resource areas logo')
            .item-info.column.top.start
              h3.m-bottom-05.text-small.dark-gray
                | {{ innerI18n.t('presentationTab.areas') }}
              p.text-normal(v-for='subject in presentation.subjects')
                | {{ innerI18n.t(`subjects.${toLowerCamelCase(subject.translationId)}`) }}
          .item.row.top.start
            img.item-logo(src='../../assets/ic_calendar.svg' alt='resource duration logo')
            .item-info.column.top.start
              h3.m-bottom-05.text-small.dark-gray
                | {{ innerI18n.t('presentationTab.duration') }}
              p.text-normal
                | {{ innerI18n.tc('presentationTab.session', presentation.duration) }}
          .item.row.top.start
            img.item-logo(src='../../assets/ic_wifi.svg' width='20px' alt='resource mode logo')
            .item-info.column.top.start
              h3.m-bottom-05.text-small.dark-gray {{ innerI18n.t('presentationTab.mode') }}
              p.text-normal {{ getImplenetationType(presentation.implementationType) }}
          .item.row.top.start
            img.item-logo(src='../../assets/ic_check_square.svg' alt='resource skills logo')
            .item-info.column.top.start
              h3.m-bottom-05.text-small.dark-gray
                | {{ innerI18n.t('presentationTab.skills') }}
              p.text-normal(v-for='skill in presentation.skills')
                | {{ innerI18n.t(`presentationTab.skillsNames.${toLowerCamelCase(skill.translationId)}`) }}
        .item-1.row.m-bottom-2.width-100(v-if='resourceHasOds')
          .column.width-100
            .row.middle.ods-title-container.m-bottom-2
              img(src='../../assets/SDG Wheel_Transparent_WEB.png' alt='sdg\'s wheel logo' width='24px')
              h3.text-big.black.m-left-1 {{ innerI18n.t('presentationTab.ods') }}
            .m-left-4.sdg-grid.width-100
              span(v-for='anOds in orderedOds')
                img.sdg-card.m-right-1(:src='getOdsLogo(anOds.translationId)' :alt='anOds.translationId')
    .recommended.column.middle.start(v-if='associated.resources.length && !hasWhiteLabel')
      carousel(
        :title='innerI18n.t("presentationTab.interest")'
        :page='associated.page'
        :totalPages='associated.totalPages'
        @getNextPage='getMoreAssociatedResources'
      )
        slide(v-for='resource in associated.resources' :key='resource.id')
          resource-card.resource-card(:resource='resource')
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { innerI18n } from '../../main'
import { toLowerCamelCase } from '../../utils/string'
import { isImage, getExtension } from '../../utils/file'
import { resourceImplementationTypesOptions, teachersTrainingReferenceId } from '@/constants/resource'

import Stars from '@/components/Stars'
import Carousel from '@/components/Carousel'
import AuthorBioTooltip from '@/components/AuthorBioTooltip'
import ResourceCard from '@/components/ResourceCard'

import defaultImage from '@/assets/empty_profile.svg'
import arrowRight from '@/assets/ic_chevron-right.svg'
import { getOEmbedHtml, getOEmbedUrl } from '../../utils/embed'
import userRole from '../../mixins/userRole'

export default {
  mixins: [userRole],
  data() {
    return {
      defaultImage,
      arrowRight,
      innerI18n,
      toLowerCamelCase,
      presentationHtml: null
    }
  },
  watch: {
    async resource(nextResource, prevResource) {
      if ((!prevResource.id || prevResource.id !== nextResource.id) && nextResource.id) {
        this.clearAssociatedResources()
        this.getAssociatedResourcesForResource({ pageNumber: 0, id: nextResource.id })
        this.getAssociatedResourcesForResource({ pageNumber: 1, id: nextResource.id })
      }
      await this.loadPresentationVideo()
    }
  },
  computed: {
    ...mapState({
      resource: state => state.resource.resource,
      ods: state => state.resource.resource.odSs,
      presentation: state => state.resource.resource.presentation,
      associated: state => state.resource.associatedResources,
      language: state => state.behavior.locale,
      innerLocale: state => state.behavior.innerLocale
    }),
    isTeacherTraining() {
      return this.resource.category.referenceId === teachersTrainingReferenceId
    },
    orderedOds() {
      return this.ods.map(ods => ods).sort((a, b) => a.id - b.id)
    },
    mediaIsNotVideo() {
      return this.resource.presentation.mediaType !== 'Video' || isImage(getExtension(this.resource.presentation.media))
    },
    singular() {
      return this.resource.presentation.duration === 1
    },
    isKrea() {
      return this.resource.category.name === 'Krea'
    },
    isPurchased() {
      return this.resource.isPurchased
    },
    resourceHasOds() {
      return this.ods.length >= 1
    },
    hasMaterials() {
      return Object.keys(this.resource.presentation.materials).some(key => this.resource.presentation.materials[key])
    }
  },
  async mounted() {
    if (!this.mediaIsNotVideo) await this.loadPresentationVideo()
  },
  methods: {
    ...mapActions([
      'hydrateResource',
      'getAssociatedResourcesForResource',
      'showElement',
      'hideElement',
      'clearAssociatedResources'
    ]),
    async loadPresentationVideo() {
      const oembedUrl = getOEmbedUrl(this.presentation.media)
      const html = await getOEmbedHtml(oembedUrl)
      this.presentationHtml = html
    },
    toTeacherTab() {
      this.$emit('toTeacher')
    },
    getImplenetationType(type) {
      const label = resourceImplementationTypesOptions.find(typeOp => typeOp.value === type).label
      return innerI18n.t(`presentationTab.implementationType.${label}`)
    },
    getAgeRangeStyle(color) {
      return {
        '--age-color': color
      }
    },
    async getMoreAssociatedResources({ pageNumber }) {
      await this.getAssociatedResourcesForResource({ pageNumber, id: this.resource.id })
    },
    getOdsLogo(ods) {
      return require(`@/assets/ods/${this.innerI18n.locale}/${ods}.png`)
    }
  },
  components: { Stars, Carousel, AuthorBioTooltip, ResourceCard }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.resource-card{
  max-width: 310px;
}

.sdg-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, 50px);
  gap: 10px;
}

.sdg-card {
  box-shadow: 0 4px 8px 0 $shadow-gray;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
  width: 50px;

  &:hover {
    box-shadow: 0 8px 16px 0 $dark-gray-translusent;
    transform: scale(1.3);
  }
}

.ods-title-container {
  min-width: 610px;

  .text-xbig {
    font-size: 20px
  }
}

.resource {
  width: 100%;
  margin-bottom: 60px;
}

.info {
  width: 100%;
  margin-right: 130px;
  max-width: 480px;
  padding-top: 20px;
}

.text-overflow{
  overflow-wrap: anywhere;
}

.rating {
  margin-bottom: 20px;

  & > * {
    margin-right: 12px;
  }
}

.rating-button-section {
  margin-bottom: 35px;
}

.benefits-desc {
  max-width: 480px;
}

.author {
  max-width: 500px;
  display: grid;
  grid-template: 'image name' 30px
    'image description' / 60px 1fr;
  gap: 0 20px;
}

.author-avatar {
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  border: 1px solid $light-gray;
  border-radius: 100%;
  grid-area: image;
}

.webinar-desc {
  padding-left: 25px;
  border-left: 1px solid $black;
}

.blue-icon {
  top: 10px;
}

.graphics {
  width: 100%;
}

.media-box {
  width: 100%;
  height: 395px;
  min-width: 300px;
  max-width: 645px;
  margin-bottom: 25px;
}

.media-box-divider {
  border-bottom: 1px solid $gray;
}

.graphics-items {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 35px;
  width: 100%;
  margin-bottom: 45px;
}

.item {
  width: 100%;
  margin-right: 20px;
}

.item-logo {
  margin-right: 15px;
}

.item-info {
  width: 100%;
  max-width: 170px;
}

.age-desc {
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    background-color: var(--age-color);
    border-radius: 4px;
    height: 8px;
    position: absolute;
    margin-right: 10px;
    width: 8px;
    left: 0px;
  }
}

.recommended {
  padding-top: 40px;
  border-top: 1px solid $light-gray;
}

.video {
  border: 0;
  width: 100%;
  height: 100%;
}

.media-picture {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.materials-items {
  margin-bottom: 20px;
  width: 100%;
}

.small-icon {
  height: 20px;
  width: 20px;
}

.author-tooltip {
  width: 100%;
  max-width: 345px;
  background-color: $white;
}

.author-description {
  padding: 30px 25px 0;
}

.author-avatar-tt {
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  border: 1px solid $light-gray;
  border-radius: 100%;
  margin-right: 20px;
}

.author-name {
  margin-bottom: 5px;
}

.external {
  background-color: $light-gray;
  padding: 18px 0 18px 18px;

  &::before {
    content: '';
    height: 40px;
    border-right: 1px solid $white;
    position: absolute;
    left: 170px;
  }
}

.web-link {
  display: inline-block;
  width: 140px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.social-icon {
  margin-right: 25px;
  height: 25px;
  width: 25px;
}
</style>
